import axios from 'axios';
export const functionMixins = {
    methods:{
        get_api_key_mix(stringKeyData){
            var md5 = require('md5')
            return md5(this.$store.state.companyData['encrypt_key']+stringKeyData)
        },

        web_hits(connectUs=0){
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
            const formData = new FormData()
            if (this.$route.name=='Division') {
                if(this.$route.params.division_id){
                    formData.append('id_division', this.$route.params.division_id)                  
                }
            } else if (this.$route.name=='Module') {
                if(this.$route.params.module_id){
                    formData.append('id_module', this.$route.params.module_id)
                }
                if(this.$route.params.division_id){
                    formData.append('id_division', this.$route.params.division_id)                  
                }
                if(this.$route.params.element_id){
                    formData.append('id_element', this.$route.params.element_id)    
                }
                if(this.$route.params.category_id){
                    formData.append('id_category', this.$route.params.category_id)
                }                
            }else{
                if (this.$route.name=='Search') {
                    if(this.$route.query.type == 'simple'){                        
                        formData.append('search_body', this.$route.query.q)       
                    }else{
                        if(this.$route.query.q) {                      
                            formData.append('search_title', this.$route.query.q)  
                        } else {
                            formData.append('id_module', this.$route.query.m)
                        }    
                    } 
                    if(this.$route.query.e){
                        formData.append('id_element', this.$route.query.e) 
                    }       
                }else{
                    if(this.$route.query.m){
                        formData.append('id_module', this.$route.query.m)
                    }
                    if(this.$route.query.d){
                        formData.append('id_division', this.$route.query.d)
                    }
                    if(this.$route.query.e){
                        formData.append('id_element', this.$route.query.e) 
                    }
                    if(this.$route.query.c){
                        formData.append('id_category', this.$route.query.c) 
                    } 
                    if(this.$route.params.id){
                        formData.append('id_cr', this.$route.params.id) 
                    }                   
                }               
            }  
            formData.append('url', (connectUs!=0)?connectUs:this.$route.path) 
            formData.append('privatekey', this.get_api_key_mix('seer'))           
            formData.append('id_session', this.$store.state.companyData['id_session']) 
            formData.append('id_company', this.$store.state.companyData['id_company']) 
            formData.append('id_language', this.$store.state.companyData['id_language']) 
            formData.append('id_eap', this.$store.state.companyData['id_eap']) 
            formData.append('name_company', this.$store.state.companyData['name_company']) 
            formData.append('company_username', this.$store.state.companyData['login_user'])

            axios.post(this.$store.state.apiUrl+'/set_web_tracker_user',formData,config)
            .then(response => {
                response = response.data[0]
                if(response === undefined || response.length == 0 ){
                    this.err='! Invalid Credential / No Access'
                }                
            })
            .catch(() => {
                this.err='Try after sometime'
            });
            
        },
        /*function to decode language /special charectors to correctly render */
        decodeHtmlLang (str) {
            var textArea = document.createElement('textarea');
            textArea.innerHTML = str;
            if(textArea.value==undefined){
                return " ";
            }else{
                return textArea.value; 
            }
            
        },

        customErrorHandler(statsCode,storeFlag){    
            if(statsCode==401){
               // alert('test alert2');
                //console.log(this.$store);
                // if(this.$store==undefined){ 
                    
                    
                //     this.$router.go('/');
                // }
                
                if(this.$store==undefined || this.$store.state.logoutFlag==0){
                    //console.log('yes 401');
                //var filename=""; 
                if(this.$store!=undefined) 
                this.$store.state.logoutFlag=1;
                
                var filename='';
                if(localStorage.filename!=undefined) {
                    filename=localStorage.filename;
                }
                
                var id_eap=localStorage.id_eap;
                localStorage.removeItem('id_session');
                localStorage.removeItem('id_company');
                
                if(filename!=""){
                  window.location.assign('/companyLogin/'+id_eap+'/'+filename);           
                }
                else{
                    //alert('fname else'+filename); 
                    if(storeFlag==1){
                        window.location.assign('/');
                    }else{
                        this.$router.go('/');
                    }
                }
                }                
                
            } 
        },
        loadExternalJsScript(path_to_file){
            const plugin = document.createElement("script");
            plugin.setAttribute(
            "src",
            path_to_file
            );
            plugin.async = true;
            document.body.appendChild(plugin);
        },
        
         /* For Form Validation */
         validateForm(name,phone,email,country,language,timeZone,message,topicc,fterms,phoneMsg,company=undefined,fname=undefined,lname=undefined,dob=undefined,hemail=undefined,bestTime=undefined,gender=undefined,hcaptcha=undefined,concernService=undefined,concernIssue=undefined,callBackRequest=undefined,caseId=undefined,contactPreference=undefined){
           // alert('b-'+bestTime);
           
            if(name!==undefined){           
                if (this.name === '') {
                    //console.log("test33333",this.$store.state.languageData['terms_check'])
                    let errMsg=this.$store.state.languageData['name']+' '+this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('name_validation_error','dynamic_form_error_required',errMsg);     
                    this.$refs.name.focus(); 
                    $('#name_validation_error').attr('aria-label',errMsg); 
                    return 'false';                           
                } 
            }
            
            if(company!==undefined){
                if (this.company === '') {
                    let errMsg=this.$store.state.languageData['companyName']+' '+this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('company_validation_error','dynamic_form_error_required',errMsg); 
                    $('#company_validation_error').attr('aria-label',errMsg);
                    this.$refs.company.focus();  
                    return 'false';
                }
            }

            if(fname!==undefined){
                if (this.fname === '') {
                    let errMsg=this.$store.state.languageData['first_name']+ ' ' +this.$store.state.languageData['required']; 
                    this.validateFormAddMarkers('fname_validation_error','dynamic_form_error_required',errMsg); 
                    $('#fname_validation_error').attr('aria-label',errMsg);
                    this.$refs.fname.focus();  
                    return 'false';
                }
            }

            if(lname!==undefined){
                if (this.lname === '') {
                    let errMsg=this.$store.state.languageData['last_name']+ ' ' +this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('lname_validation_error','dynamic_form_error_required',errMsg); 
                    $('#lname_validation_error').attr('aria-label',errMsg);
                    this.$refs.lname.focus();  
                    return 'false';
                }
            }

            if(dob!==undefined){
                if (this.dob === '') {
                    let errMsg=this.$store.state.languageData['date_birth']+ ' ' +this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('dob_validation_error','dynamic_form_error_required',errMsg); 
                    $('#dob_validation_error').attr('aria-label',errMsg);
                    this.$refs.dob.focus();  
                    return 'false';
                }
            }
            if(caseId!==undefined){
                if (this.caseId === '') {
                    let errMsg=this.$store.state.languageData['caseId'] + ' sample case ' +this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('caseId_validation_error','dynamic_form_error_required',errMsg); 
                    $('#caseId_validation_error').attr('aria-label',errMsg);
                    this.$refs.caseId.focus();  
                    return 'false';
                }
            }
            if(contactPreference!==undefined){
                if (this.contactPreference === '') {
                    let errMsg=this.$store.state.languageData['contactPreference'] + ' ' +this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('contactPreference_validation_error','dynamic_form_error_required',errMsg); 
                    $('#contactPreference_validation_error').attr('aria-label',errMsg);
                    this.$refs.contactPreference.focus();
                    return 'false';
                }
            }
            if(concernService!==undefined){
                if (this.concernService === '') {
                    let errMsg=this.$store.state.languageData['concern_product']+ ' ' +this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('concern_service_validation_error','dynamic_form_error_required',errMsg); 
                    $('#concern_service_validation_error').attr('aria-label',errMsg);
                    this.$refs.concernService.focus();  
                    return 'false';
                }
            }

            if(concernIssue!==undefined){
                if (this.concernIssue === '') {
                    let errMsg=this.$store.state.languageData['concern_issue']+ ' ' +this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('concern_issue_validation_error','dynamic_form_error_required',errMsg); 
                    $('#concern_issue_validation_error').attr('aria-label',errMsg);
                    this.$refs.concernIssue.focus();  
                    return 'false';
                }
            }

            if(callBackRequest!==undefined){
                if (this.callBackRequest === '') {
                    let errMsg=this.$store.state.languageData['concern_callback']+ ' ' +this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('callBackRequest_validation_error','dynamic_form_error_required',errMsg); 
                    $('#callBackRequest_validation_error').attr('aria-label',errMsg);
                    this.$refs.callBackRequest.focus();  
                    return 'false';
                }
            }

            if(phone!==undefined){
                if (this.phone === '') {   
                    let errMsg=this.$store.state.languageData['phone']+ ' ' +this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('phone_validation_error','dynamic_form_error_required',errMsg);  
                    this.$refs.phone.focus(); 
                    $('#phone_validation_error').attr('aria-label',errMsg);
                    return 'false'; 
                } 
            }

            if(email!==undefined){
                var ret=this.htmlfiveValidationCheck(this.$refs.email);
                if (this.email==="" || ret) {  
                    let errMsg= this.$store.state.languageData['email'] + ' ' +this.$store.state.languageData['required'] +  ' / ' + this.$store.state.languageData['pleaseEmailFormat'];
                    this.validateFormAddMarkers('email_validation_error','dynamic_form_error_required',errMsg);  
                    this.$refs.email.focus(); 
                    $('#email_validation_error').attr('aria-label',errMsg);
                    return 'false'; 
                } 
            }

            if(country!==undefined){
                if (this.country === '') {
                    let errMsg=this.$store.state.languageData['country']+ ' ' +this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('country_validation_error','dynamic_form_error_required',errMsg); 
                    $('#country_validation_error').attr('aria-label',errMsg);
                    this.$refs.country.focus(); 
                    return 'false'; 
                } 
            }

            if(phoneMsg!==undefined){
                if (this.phoneMsg === '') {
                    let errMsg=this.$store.state.languageData['phoneMsg']+ ' ' +this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('phoneMsg_validation_error','dynamic_form_error_required',errMsg); 
                    $('#phoneMsg_validation_error').attr('aria-label',errMsg);
                    this.$refs.phoneMsg.focus();  
                    return 'false';
                }
            }

            if(topicc!==undefined){            
                if (this.topicc === '') { 
                    let errMsg= this.$store.state.languageData['suggestedTopic']+ ' ' + this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('topicc_validation_error','dynamic_form_error_required',errMsg);     
                    $('#topicc_validation_error').attr('aria-label',errMsg);
                    this.$refs.topicc.focus();  
                    return 'false';                           
                } 
            }

            if(language!==undefined){
                if (this.language === '') {
                    let errMsg= this.$store.state.languageData['language']+ ' ' +this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('language_validation_error','dynamic_form_error_required',errMsg); 
                    $('#language_validation_error').attr('aria-label',errMsg);
                    this.$refs.language.focus(); 
                    return 'false'; 
                } 
            }

            if(timeZone!==undefined){
                if (this.timeZone === '') {
                    let errMsg= this.$store.state.languageData['timeZone']+ ' ' +this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('timeZone_validation_error','dynamic_form_error_required',errMsg); 
                    $('#timeZone_validation_error').attr('aria-label',errMsg);
                    this.$refs.timeZone.focus(); 
                    return 'false'; 
                } 
            }

            if(hemail!==undefined){
                if (this.hemail === '') {
                    let errMsg= this.$store.state.languageData['email_home']+ ' ' +this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('hemail_validation_error','dynamic_form_error_required',errMsg); 
                    $('#hemail_validation_error').attr('aria-label',errMsg);
                    this.$refs.hemail.focus();  
                    return 'false';
                }
            }

            if(bestTime!==undefined){
                if (this.bestTime === '') {
                    let errMsg= this.$store.state.languageData['phoneTimes'] + ' ' +  this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('bestTime_validation_error','dynamic_form_error_required',errMsg); 
                    $('#bestTime_validation_error').attr('aria-label',errMsg);
                    this.$refs.bestTime.focus();  
                    return 'false';
                }
            }

            if(message!==undefined){
                if (this.message === '') {
                    let errMsg= this.$store.state.languageData['reason']+ ' ' +this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('message_validation_error','dynamic_form_error_required',errMsg); 
                    $('#message_validation_error').attr('aria-label',errMsg);
                    this.$refs.message.focus(); 
                    return 'false'; 
                } 
            }           

            if(fterms!==undefined){
                if (this.fterms === '') {
                    let errMsg=this.$store.state.languageData['accept_terms']+',' +this.$store.state.languageData['privacy'] + ' ' +this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('fterms_validation_error','dynamic_form_error_required',errMsg); 
                    $('#fterms_validation_error').attr('aria-label',errMsg);
                    this.$refs.fterms.focus();  
                    return 'false';
                }
            }

            if(gender!==undefined){
                if (this.gender === '') {
                    let errMsg=this.$store.state.languageData['gender'] + ' ' +this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('gender_validation_error','dynamic_form_error_required',errMsg); 
                    $('#gender_validation_error').attr('aria-label',errMsg);
                    this.$refs.gender.focus();  
                    return 'false';
                }
            }
            if(hcaptcha!==undefined){            
                if (hcaptcha == false) {
                    let errMsg=this.$store.state.languageData['captcha_reason'];
                    this.validateFormAddMarkers('hccaptcha_validation_error','dynamic_form_error_required',errMsg);     
                    //this.$refs.name.focus(); 
                    $('#hccaptcha_validation_error').attr('aria-label',errMsg); 
                    return 'false';
                } 
            }
            

        },

        validateFormAddMarkers(idValue,errorClass,textContent){
            document.getElementById(idValue).textContent = textContent;
            var element = document.getElementById(idValue);
            element.classList.add(errorClass);
        },

        validateFormRemoveMarkers(value){            
            var element = document.getElementById(value);
            element.classList.remove('dynamic_form_error_required');
            document.querySelector('#'+value).textContent = ' ';
        },
        validateEmailid(eemail) {
            //console.log('yeshere');
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,15})+$/.test(eemail)) {
                return false;
            } else {
                return true;
            }
        },
        /*check text contain only alphabets*/
        isLetter(e) {
            let char = String.fromCharCode(e.keyCode);
            if (/^[A-Za-z]+$/.test(char)) return true;
            else e.preventDefault();
        },
        /* for all utf-8 charset with space */
        isLetterWithSpace(e) {
            let char = String.fromCharCode(e.keyCode);
            if (/[\p{L}\p{Zs}]/u.test(char)) return true;
            else { 
                e.preventDefault();
            }    
        },
        htmlfiveValidationErr(e){
            const isValid = e.target.reportValidity();
            e.target.setAttribute('aria-invalid', !isValid);
        },
        /*check with $ref*/
        htmlfiveValidationCheck(ref){
            const isValid = ref.checkValidity();  
            //ref.reportValidity();          
            ref.setAttribute('aria-invalid', !isValid);
            return !isValid;
        },
        /*check text contain only number and -*/
        isNumberWithHyphen(e) {
            let char = String.fromCharCode(e.keyCode);
            if (/[0-9/-]/g.test(char)) return true;
            else {
                e.preventDefault();
            }
        },

        //onkeydown="return /[\p{L}\p{Zs}]/u.test(event.key)"
         /* For Form Validation */
         tglMnu(){
			if(document.body.classList.contains('offcanvas')){
		 	//console.log('offcanvasind');
			}
			else{
				this.isActive=true;
				document.getElementById("megazineMenutoglr").classList.add("active");
				this.toggleMegaMenuEvent();
			}
			
		}
    }   
}